import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconShareAndroid } from '@sorare/core/src/atoms/icons/system/iconShareAndroid.ts';
import { SocialShare } from '@sorare/core/src/components/user/SocialShare/index.tsx';
import {
  socialShareEventContext,
  socialShareEventName,
} from '@sorare/core/src/lib/events.ts';

import { useSquadInviteShare } from '#src/hooks/squad/useSquadInviteShare.ts';

type Props = {
  squadId: string;
};

export const SquadInviteButton = ({ squadId }: Props) => {
  const { url, message } = useSquadInviteShare(squadId);

  return (
    <SocialShare
      url={url}
      message={message}
      trackingEventName={socialShareEventName.SHARE_SQUAD_INVITE}
      trackingEventContext={socialShareEventContext.SQUAD}
      renderButton={({ onClick }) => (
        <Button
          size="large"
          color="secondary"
          fullWidth
          onClick={onClick}
          startIcon={<FontAwesomeIcon icon={iconShareAndroid} />}
        >
          <FormattedMessage defaultMessage="Invite Friends" />
        </Button>
      )}
    />
  );
};
